import format from '../node_modules/date-fns/esm/format/index.js';
import parseDate from './parse-date.js';

/**
 * @func formatDate
 * @param {date} date - date to be formatted (accepts date string, ISO string, or date object)
 * @param {string} style - style of formatting (defaults to 'date' but also accepts 'l', 'input', or 'monthYear')
 * @param {string} nullPlaceholder - value to be returned if date is invalid, defaults to empty string
 * @param {string} format - optional prop allows you to pass any date-fns formatting to formatDate for custom format
 * @return {string}
 * @desc Formats date in mm/dd/yyyy ('date'), m/d/yyyy ('l'), yyyy-mm-dd ('input'), mm/yyyy ('monthYear) or a custom format
 * ```js
 * formatDate('1/2/20');
 * // returns '01/02/2020'
 *
 * formatDate('1/2/20', { style: 'input' });
 * // returns '2020-01-02'
 *
 * formatDate('1/2/20', { format: 'MM/dd/yy' });
 * // returns '01/02/20'
 * ```
 * @memberof module:Date
 * @instance
 */
function formatDate(date, { format: dateFnsFormat, nullPlaceholder = '', style } = {}) {
    const parsedDate = parseDate(date);
    if (!parsedDate)
        return nullPlaceholder;
    if (style === 'l') {
        return format(parsedDate, 'M/d/yyyy');
    }
    else if (style === 'input') {
        return format(parsedDate, 'yyyy-MM-dd');
    }
    else if (style === 'monthYear') {
        return format(parsedDate, 'MM/yyyy');
    }
    else if (dateFnsFormat) {
        return format(parsedDate, dateFnsFormat);
    }
    else {
        return format(parsedDate, 'MM/dd/yyyy');
    }
}

export { formatDate as default };
